import React from 'react';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { apiPut } from '../../../api/client';
import { toast } from 'sonner';

interface SmtpForm {
  smtpHost: string;
  smtpPort: string;
  smtpUser: string;
  smtpPass: string;
  smtpFrom: string;
}

interface SmtpStepProps {
  form: SmtpForm;
  onChange: (f: SmtpForm) => void;
}

export function SmtpStep({ form, onChange }: SmtpStepProps) {
  const [testing, setTesting] = React.useState(false);

  const handleSave = async () => {
    setTesting(true);
    try {
      await apiPut('/admin/smtp', {
        host: form.smtpHost || null,
        port: Number(form.smtpPort) || 587,
        user: form.smtpUser || null,
        pass: form.smtpPass || null,
        from: form.smtpFrom || null,
      });
      toast.success('Configurazione SMTP salvata.');
    } catch (e) {
      toast.error((e as Error).message);
    } finally {
      setTesting(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Configura il server SMTP per l'invio di email (notifiche, contratti).
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gap: '0.75rem' }}>
        <Input label="Host SMTP" value={form.smtpHost}
          onChange={e => onChange({ ...form, smtpHost: e.target.value })}
          placeholder="smtp.gmail.com" />
        <Input label="Porta" type="number" value={form.smtpPort}
          onChange={e => onChange({ ...form, smtpPort: e.target.value })}
          placeholder="587" />
      </div>
      <Input label="Username" value={form.smtpUser}
        onChange={e => onChange({ ...form, smtpUser: e.target.value })}
        placeholder="tuo@email.com" />
      <Input label="Password / App Password" type="password" value={form.smtpPass}
        onChange={e => onChange({ ...form, smtpPass: e.target.value })}
        placeholder="••••••••" />
      <Input label="Mittente" value={form.smtpFrom}
        onChange={e => onChange({ ...form, smtpFrom: e.target.value })}
        placeholder='"Studio Fotografico" <tuo@email.com>' />
      <Button variant="ghost" onClick={handleSave} loading={testing} style={{ alignSelf: 'flex-start' }}>
        Salva configurazione SMTP
      </Button>
    </div>
  );
}
